import React from 'react';

const RadarCapsule = ({ 
  trackerBtnStyle, 
  ongoingOrders, 
  showTracker, 
  setShowTracker, 
  activeTab 
}) => {
  if (!trackerBtnStyle || showTracker) return null;
  
  // 💥 核心修改：战时雷达全站显示，但没单子时的"订单档案"仅在"订单"页面(activeTab==="订单")显影
  if (trackerBtnStyle.isHistory && activeTab !== "订单") return null;

  return (
    <div 
      onClick={() => setShowTracker(true)} 
      style={{ 
        position: "fixed", 
        bottom: "110px", 
        left: "15px", 
        zIndex: 999, 
        background: trackerBtnStyle.bg, 
        color: trackerBtnStyle.color, 
        padding: "10px 20px", 
        borderRadius: "30px", 
        border: "3px solid black", 
        boxShadow: "4px 4px 0 rgba(0,0,0,1)", 
        fontWeight: "900", 
        cursor: "pointer", 
        display: "flex", 
        alignItems: "center", 
        gap: "8px", 
        fontSize: "14px", 
        animation: ongoingOrders.length > 0 ? "pulse 2s infinite" : "none" 
      }}
    >
      {trackerBtnStyle.text}
      {/* 💥 核心修改：如果是历史订单档案（没有进行中的订单），则隐藏数字角标 */}
      {!trackerBtnStyle.isHistory && (
        <span style={{ 
          background: trackerBtnStyle.bg === '#000' || trackerBtnStyle.bg === '#4CAF50' ? 'white' : 'black', 
          color: trackerBtnStyle.bg === '#000' || trackerBtnStyle.bg === '#4CAF50' ? 'black' : 'white', 
          borderRadius: "50%", 
          padding: "2px 6px", 
          fontSize: "12px" 
        }}>
          {ongoingOrders.length}
        </span>
      )}
    </div>
  );
};

export default RadarCapsule;
